import { render } from "./milestone-plan-onboarding-dialog-content.vue?vue&type=template&id=cd947496&ts=true"
import script from "./milestone-plan-onboarding-dialog-content.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-onboarding-dialog-content.vue?vue&type=script&lang=ts"

import "./milestone-plan-onboarding-dialog-content.vue?vue&type=style&index=0&id=cd947496&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__